module.exports = __webpack_public_path__ + "img/banner3_5_vi.cefa363f.png";